import axios from "axios";

// The legacy PromoStore Overview save uses the default Axios client without
// passing the JWT. Add it only to the PromoStore edit endpoint when absent.
axios.interceptors.request.use((config) => {
  const url = String(config.url || "");
  if (
    String(config.method || "").toLowerCase() === "put" &&
    /\/promostores\/edit-promostore\/\d+(?:[/?#]|$)/.test(url) &&
    !config.headers?.accessToken &&
    !config.headers?.Authorization
  ) {
    const token = localStorage.getItem("accessToken");
    if (token) config.headers = { ...(config.headers || {}), accessToken: token };
  }
  return config;
});
